import CartItemsExternal from './CartItemsExternal';

export default CartItemsExternal;
